// @ts-strict-ignore
import { createContext } from 'react';
import type { PopulatedThreshold, ThresholdType } from '../../../store/engine/types';

export const ThresholdContext = createContext<{
  threshold: PopulatedThreshold;
  leftDataType?: string;
  thresholdType?: ThresholdType;
}>({
  threshold: undefined,
  leftDataType: '',
});
